// src/pages/value.js
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';
import './value.css';

const values = [
  {
    title: 'Security First',
    desc: 'We build products with security as the foundation, not an afterthought. Every decision we make prioritizes the protection of sensitive data and critical infrastructure.',
  },
  {
    title: 'Ethical Innovation',
    desc: 'We push the boundaries of AI while maintaining the highest ethical standards. Our innovations are designed to enhance human capabilities, not replace them.',
  },
  {
    title: 'Regulatory Excellence',
    desc: 'We excel at navigating complex regulatory landscapes, ensuring our solutions exceed compliance requirements while remaining adaptable to evolving standards.',
  },
  {
    title: 'Meaningful Impact',
    desc: 'We measure our success by the tangible difference our technology makes for our clients and the people they serve, from patients to military personnel.',
  },
];

const Value = () => {
  return (
    <div className="value-page-container app-content">
      <Navbar />

      <section className="about-values value-page">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Our Core Values
        </motion.h2>

        <div className="values-grid">
          {values.map((item, idx) => (
            <motion.div
              key={item.title}
              className="value-card"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
              whileHover={{ y: -8 }}
            >
              <div className="value-icon" data-icon={`0${idx + 1}`}></div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Value;
